import styles from "../../styles/PLMApp.module.css";
// src/components/plm/SideProgressWidget.jsx

import { PLM_CATEGORIES } from "../../data/constants";
import { stepDocId } from "../../utils/utils";
import AnimatedDonut from "./AnimatedDonut";
import AnimatedCategoryBar from "./AnimatedCategoryBar";

export default function SideProgressWidget({ steps, supplierId }) {
  const allKeys = PLM_CATEGORIES.flatMap((cat) =>
    cat.steps.map((_, i) => stepDocId(supplierId, cat.id, i)),
  );
  const total = allKeys.length;
  const done = allKeys.filter((k) => steps[k]?.status === "done").length;
  const applicable = allKeys.filter(
    (k) => steps[k]?.status !== "not_needed",
  ).length;
  const overallPct = applicable > 0 ? Math.round((done / applicable) * 100) : 0;

  return (
    <div className={styles.sideProgressWidget}>
      <div className={styles.sideProgressTitle}>Lifecycle Progress</div>

      <AnimatedDonut pct={overallPct} />

      <div className={styles.sideProgressBars}>
        {PLM_CATEGORIES.map((cat) => {
          const keys = cat.steps.map((_, i) =>
            stepDocId(supplierId, cat.id, i),
          );
          const catDone = keys.filter(
            (k) => steps[k]?.status === "done",
          ).length;
          const catApplicable = keys.filter(
            (k) => steps[k]?.status !== "not_needed",
          ).length;
          const catPct =
            catApplicable > 0 ? Math.round((catDone / catApplicable) * 100) : 0;
          return (
            <div key={cat.id} className={styles.sideProgressBarRow}>
              <span className={styles.sideProgressBarLabel}>{cat.name}</span>
              <AnimatedCategoryBar pct={catPct} color={cat.color} />
              <span className={styles.sideProgressPct}>{catPct}%</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
